import { IConfig, imageKit, setConfig } from '@meitu/wasm-lib';
import { getFramework, IFramework } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';

const WASM_READY_EVENT = 'wasm-ready-event';
export class Wasm {
    private isReady = false;
    private framework: IFramework;

    constructor(private id: string) {
        this.framework = getFramework(this.id);
    }

    getIsReady() {
        return this.isReady;
    }

    onWasmReady(fn: () => void) {
        const handler = this.framework.events.on(WASM_READY_EVENT, fn);
        return () => {
            this.framework.events.off(handler);
        };
    }

    async init(args?: { success?: () => Promise<void>; fail?: () => Promise<void> }) {
        try {
            const publicUrl = this.framework.getConfig().PUBLIC_URL || '';
            console.log('wasm publicUrl', publicUrl);
            const prefix = publicUrl.replace(/^\./, '').replace(/\/$/, ''); // 需要去掉开头的 . 符号和结尾的斜杠才能正常加载资源文件
            setConfig({ debug: false } as IConfig, prefix);
            await imageKit.init(prefix);
            this.isReady = true;
            if (args?.success) {
                await args.success();
            }
            // 移到业务加载通过 success
            //     await this.framework
            //         .getInstance<{
            //             loadWasmAssets: () => Promise<unknown>;
            //         }>('TextLayer')
            //         .loadWasmAssets();
            this.framework.events.emit(WASM_READY_EVENT);
        } catch (error) {
            if (args?.fail) {
                await args.fail();
            }
            console.error('initWasm error', error);
            // @2024-09-27 跟PC客户端确认约12%的用户默认不开启硬件加速，不开启该开关时，wasm初始化会失败。
            // 不再收集该信息，报错过多
            // if (!isIntl) {
            //     Sentry.captureMessage(
            //         '初始化 initWasm 失败_____' +
            //             JSON.stringify({ e, ...trackInfo })
            //     );
            // }
        }
    }
}

/**
 * wasm 插件扩展
 */
export const wasmExtension: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'wasm-extension',
    createInstance({ identity }) {
        return [{ key: 'Wasm', value: new Wasm(identity) }];
    },
};
